import React, { useState, useEffect } from 'react';
import './dynamicPackage.less';
import DynamicPage from './DynamicPage';

type DynamicPageEditProps = {
  isPreviewMode: any;
  selectedInstance: any;
  setSelectedInstance: any;
};

export default function DynamicPageEdit({
  isPreviewMode,
  selectedInstance,
  setSelectedInstance,
}: DynamicPageEditProps) {
  return (
    <DynamicPage
      isEdit={true}
      isPreviewMode={isPreviewMode}
      selectedInstance={selectedInstance}
      setSelectedInstance={setSelectedInstance}
    />
  );
}
